/**
 * Copyright © INOVUA TRADING.
 *
 * This source code is licensed under the Commercial License found in the
 * LICENSE file in the root directory of this source tree.
 */
"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireWildcard(require("react"));
var _join = _interopRequireDefault(require("@inovua/reactdatagrid-community/packages/join"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var DragRowArrow = function (_Component) {
  (0, _inherits2.default)(DragRowArrow, _Component);
  var _super = _createSuper(DragRowArrow);
  function DragRowArrow(props) {
    var _this;
    (0, _classCallCheck2.default)(this, DragRowArrow);
    _this = _super.call(this, props);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "dragRowArrowRef", void 0);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "setTop", function (top) {
      if (_this.dragRowArrowRef && _this.dragRowArrowRef.current) {
        _this.dragRowArrowRef.current.style.top = "".concat(top + _this.state.offset, "px");
      }
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "setHeight", function (height) {
      if (height !== _this.state.height) {
        _this.setState({
          height: height
        });
      }
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "setLeft", function (left) {
      if (left !== _this.state.left) {
        _this.setState({
          left: left
        });
      }
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "setOffset", function (offset) {
      _this.setState({
        offset: offset
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "setVisible", function (visible) {
      if (visible !== _this.state.visible) {
        _this.setState({
          visible: visible
        });
      }
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "setValid", function (isValid) {
      if (isValid !== _this.state.isValid) {
        _this.setState({
          isValid: isValid
        });
      }
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "render", function () {
      var className = (0, _join.default)('InovuaReactDataGrid__row-reorder-arrow', _this.state.isValid ? 'InovuaReactDataGrid__row-reorder-arrow--valid' : 'InovuaReactDataGrid__row-reorder-arrow--invalid');
      var style = Object.assign({
        left: _this.state.left,
        opacity: _this.state.visible ? 1 : 0
      }, _this.props.rowReorderArrowStyle);
      return _react.default.createElement("div", {
        ref: _this.dragRowArrowRef,
        className: className,
        style: style
      });
    });
    _this.state = {
      visible: false,
      offset: 0,
      top: 0,
      left: 0,
      height: 0,
      isValid: true
    };
    _this.dragRowArrowRef = (0, _react.createRef)();
    return _this;
  }
  return (0, _createClass2.default)(DragRowArrow);
}(_react.Component);
var _default = DragRowArrow;
exports.default = _default;